import {
  IResponseAgentLevels,
  IResponseAgents,
  IResponseDistributorLevels,
  IResponseDistributors,
  IResponseTechnicians,
} from '~/utils/interface/utility';
import axiosClient from './axiosClient';

const utilityApi = {
  getListDistributors() {
    const url = `api/utility/list-distributors`;
    return axiosClient.get<IResponseDistributors[]>(url);
  },
  getListDistributorLevels() {
    const url = `api/utility/distributor-levels`;
    return axiosClient.get<IResponseDistributorLevels[]>(url);
  },
  getListAgents() {
    const url = `api/utility/list-agents`;
    return axiosClient.get<IResponseAgents[]>(url);
  },
  getOptionBusiness() {
    const url = `/api/utility/option-business`;
    return axiosClient.get<any>(url);
  },
  getAgentLevels() {
    const url = `api/utility/agent-levels`;
    return axiosClient.get<IResponseAgentLevels[]>(url);
  },
  getListTechnicians() {
    return axiosClient.get<IResponseTechnicians[]>('api/utility/list-technician');
  },
};
export default utilityApi;
